import { LayoutUtilsService } from './../../../../core/_base/crud/utils/layout-utils.service';
import { AppState } from './../../../../core/reducers/index';
import { Observable } from 'rxjs';
import { UsersService } from '@app/api/users.service';
import { Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import * as address from 'assets/json/address.json';
import { UserAddressService } from '@app/api/api';
import { currentUser, User } from '@app/core/auth';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { map, startWith } from 'rxjs/operators';
import { UtilService } from '@app/services/util.service';
import { MatDialog } from '@angular/material';
import { AppModalUpdateAddressComponent } from '../app-modal-update-address/app-modal-update-address.component';
import { NewAddressTabComponent } from '../new-address-tab/new-address-tab.component';

@Component({
  selector: 'meu-app-book-address',
  templateUrl: './app-book-address.component.html',
  styleUrls: ['./app-book-address.component.scss'],
})
export class AppBookAddressComponent implements OnInit {
  @Input() isDesktop: boolean = false;
  @Input() isModal: boolean = false;
  @Input() userId;
  @Input() itemChoosedId: string;
  @Output() isEditing = new EventEmitter();
  @Output() isCreateDone = new EventEmitter();
  @Output() addressID = new EventEmitter();
  @Output() addressOutput = new EventEmitter();

  lstUpdateAddress = [];

  constructor(
    private router: Router,
    private userService: UsersService,
    private userAddressService: UserAddressService,
    private ref: ChangeDetectorRef,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private layoutUtilsService: LayoutUtilsService,
    private dialog: MatDialog
  ) {}
  addressForm = new FormGroup({
    fullname: new FormControl('', [Validators.required]),
    province: new FormControl('', [Validators.required]),
    district: new FormControl(''),
    ward: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    is_company: new FormControl('', [Validators.required]),
    is_default: new FormControl(''),
    user_id: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
  });
  lstAddress: any = [];
  lstAddressJson: any = [];
  lstProvince: any = [];
  lstDistrict: any = [];
  lstWard: any = [];
  formType: any = '';
  hideLstAddress: boolean = false;
  user$: Observable<User>;
  myInfo: any;
  addressIDUpdate: any;
  hasFormErrors: boolean = false;
  filteredOptionsLstProvince: Observable<string[]>;
  filteredOptionsLstDistrict: Observable<string[]>;
  filteredOptionsLstWard: Observable<string[]>;
  closeModalCreate: boolean = false;
  ngOnInit() {
    if (this.userId) {
      //admin
      this.getAddressByUserId(this.userId);
    } else {
      this.getAllMyAddress();
    }
    //this.address = decodeURIComponent(JSON.parse(this.address));
    this.lstAddressJson = Object.values(JSON.parse(JSON.stringify(address.default)));
    this.lstProvince = [...this.lstAddressJson.map((x) => x.name)];
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((user) => {
      this.myInfo = user;
    });
    this.filteredOptionsLstProvince = this.addressForm.get('province').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterProvince(value))
    );
  }
  private _filterProvince(value: string): string[] {
    if (value != null) {
      const filterValue = UtilService.slugify(value.toLowerCase());
      return this.lstProvince.filter((option) =>
        UtilService.slugify(option.toLowerCase()).includes(filterValue)
      );
    }
  }
  private _filterDistrict(value: string): string[] {
    if (value != null) {
      const filterValue = UtilService.slugify(value.toLowerCase());
      return this.lstDistrict
        .map((x) => x.name)
        .filter((option) => UtilService.slugify(option.toLowerCase()).includes(filterValue));
    }
  }
  private _filterWard(value: string): string[] {
    if (value != null) {
      const filterValue = UtilService.slugify(value.toLowerCase());
      return this.lstWard
        .map((x) => x.name)
        .filter((option) => UtilService.slugify(option.toLowerCase()).includes(filterValue));
    }
  }
  deleteAddress(id) {
    const title = 'Xóa địa chỉ';
    const description = 'Bạn có chắc chắn muốn xóa ?';
    const waitDesciption = 'Đang xử lý...';

    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.userAddressService.apiUserAddressesIdDelete(id).subscribe((res) => {
        if (res.success) {
          this.formType = '';
          this.reloadAddressList();
        }
      });
    });
  }
  updateLstDistrict() {
    //this.districtUser = "";
    if (this.addressForm.value.province != null && this.addressForm.value.province != '') {
      this.addressForm.patchValue({
        district: '',
        ward: '',
      });
      let address = this.lstAddressJson.find((x) => x.name == this.addressForm.value.province);
      this.lstDistrict = [];
      if (address != null) {
        this.lstDistrict = Object.values(JSON.parse(JSON.stringify(address.districts)));
      }
      this.filteredOptionsLstDistrict = this.addressForm.get('district').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterDistrict(value))
      );
    }
  }
  updateListWard() {
    if (this.addressForm.value.district != null && this.addressForm.value.district != '') {
      //this.addressForm.controls.wards.setValue('');
      let district = this.lstDistrict.find((x) => x.name == this.addressForm.value.district);
      this.lstWard = [];
      if (district != null) {
        this.lstWard = Object.values(JSON.parse(JSON.stringify(district.wards)));
      }
      this.filteredOptionsLstWard = this.addressForm.get('ward').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterWard(value))
      );
    }
  }
  createMyNewAddress() {
    this.addressForm.patchValue({
      user_id: this.userId || (this.myInfo ? this.myInfo.id : ''),
      country: 'Việt Nam',
    });
    const controls = this.addressForm.controls;
    if (this.addressForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      //this.hasFormErrors = true;
      return;
    } else {
      if (this.addressForm.value.is_default == '' || this.addressForm.value.is_default == null) {
        this.addressForm.patchValue({
          is_default: false,
        });
      }

      this.userAddressService.apiUserAddressesPost(this.addressForm.value).subscribe((res) => {
        if (res.success) {
          this.reloadAddressList();
          this.formType = '';
          this.resetDataForm();
          this.hasFormErrors = false;
          this.isCreateDone.emit(true);
          this.hideLstAddress = false;
        }
      });
    }
  }
  updateMyAddress() {
    this.addressForm.patchValue({
      user_id: this.addressForm.value.user_id || (this.myInfo ? this.myInfo.id : ''),
      country: 'Việt Nam',
    });
    const controls = this.addressForm.controls;
    if (this.addressForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      //this.hasFormErrors = true;
      return;
    } else {
      if (this.addressForm.value.is_default == '' || this.addressForm.value.is_default == null) {
        this.addressForm.patchValue({
          is_default: false,
        });
      }
      this.userAddressService
        .apiUserAddressesIdPut(this.addressIDUpdate, this.addressForm.value)
        .subscribe((res) => {
          if (res.success) {
            this.reloadAddressList();
            this.addressID.emit(this.itemChoosedId);
            this.formType = '';
            this.hasFormErrors = false;
            this.toastr.success('Cập nhật thông tin thành công');
            this.cancelEditModal();
          } else {
            this.toastr.error(res.message);
          }
        });
    }
  }
  scrollToFormCreate() {
    setTimeout(function () {
      window.scrollTo(0, document.body.scrollHeight);
    }, 0.5);
  }
  changeAddressShip(index) {
    //Just one check for one checkbox
    for (let i = 0; i < this.lstAddress.length; i++) {
      if (i != index) {
        this.lstAddress[i].isChoosed = false;
      } else {
        if (this.lstAddress[index].isChoosed == true) {
          this.itemChoosedId = this.lstAddress[index].id;
          this.addressID.emit(this.itemChoosedId);
        } else {
          this.addressID.emit('');
        }
      }
    }

    this.ref.detectChanges();
  }
  getAddressByUserId(userId) {
    this.userAddressService.apiUserUserIDUserAddressesGet(userId).subscribe((res) => {
      if (res.success) {
        this.lstAddress = res.data;
        let checkDefault = this.lstAddress.findIndex((p) => p.id == this.itemChoosedId);
        for (var i = 0; i < this.lstAddress.length; i++) {
          let parts = [];
          if (this.lstAddress[i].address) parts.push(this.lstAddress[i].address);
          if (this.lstAddress[i].ward) parts.push('phường ' + this.lstAddress[i].ward);
          if (this.lstAddress[i].district) parts.push('quận ' + this.lstAddress[i].district);
          if (this.lstAddress[i].province) parts.push(this.lstAddress[i].province);
          if (this.lstAddress[i].country) parts.push(this.lstAddress[i].country);
          this.lstAddress[i].fullAddress = parts.join(', ');
          //Checked address
          if (checkDefault > -1) {
            if (this.itemChoosedId == this.lstAddress[i].id) {
              this.lstAddress[i].isChoosed = true;
            }
          } else {
            if (this.lstAddress[i].is_default) this.lstAddress[i].isChoosed = true;
            else this.lstAddress[i].isChoosed = false;
          }
        }

        this.lstAddress = [...this.lstAddress];
        this.addressOutput.emit(this.lstAddress);
        this.ref.detectChanges();
      }
    });
  }
  getAllMyAddress() {
    this.lstAddress = [];
    this.userService.apiUsersMyaddressGet().subscribe((res) => {
      if (res.success) {
        this.lstAddress = res.data;
        let checkDefault = this.lstAddress.findIndex((p) => p.id == this.itemChoosedId);
        for (var i = 0; i < this.lstAddress.length; i++) {
          let parts = [];
          if (this.lstAddress[i].address) parts.push(this.lstAddress[i].address);
          if (this.lstAddress[i].ward) parts.push('phường ' + this.lstAddress[i].ward);
          if (this.lstAddress[i].district) parts.push('quận ' + this.lstAddress[i].district);
          if (this.lstAddress[i].province) parts.push(this.lstAddress[i].province);
          if (this.lstAddress[i].country) parts.push(this.lstAddress[i].country);
          this.lstAddress[i].fullAddress = parts.join(', ');
          //Checked address
          if (checkDefault > -1) {
            if (this.itemChoosedId == this.lstAddress[i].id) {
              this.lstAddress[i].isChoosed = true;
            }
          } else {
            if (this.lstAddress[i].is_default) this.lstAddress[i].isChoosed = true;
            else this.lstAddress[i].isChoosed = false;
          }
        }

        this.lstAddress = [...this.lstAddress];
        this.addressOutput.emit(this.lstAddress);
        this.ref.detectChanges();
      }
    });
  }

  openModalCreateAdministrativeDesktop() {
    const dialogRef = this.dialog.open(NewAddressTabComponent, {
      data: { isModal: true, userId: this.userId || null },
      width: '600px',
      maxWidth: '95vw',
      panelClass: 'custom-address-modal'
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.event) {
        this.reloadAddressList();
      }
    });
  }

  private reloadAddressList(): void {
    if (this.userId) {
      this.getAddressByUserId(this.userId);
    } else {
      this.getAllMyAddress();
    }
  }

  //Add property isChoose for checkbox
  openFormCreateDesktop() {
    if (this.lstAddress.length == 6) {
      this.toastr.warning(
        'Bạn chỉ được tạo tối đa 6 địa chỉ, vui lòng xoá một địa chỉ trước khi tạo mới.',
        ''
      );
    } else {
      if (this.isDesktop == true) {
        this.formType = 'create';
        this.addressForm.reset();
        this.addressForm.patchValue({
          province: '',
          district: '',
          ward: '',
        });
        this.scrollToFormCreate();
      } else {
        if (!this.isModal) {
          this.router.navigate(['/myprofile/mybookaddress/create']);
        } else {
          this.formType = 'create';
          this.addressForm.reset();
          this.addressForm.patchValue({
            province: '',
            district: '',
            ward: '',
          });
          this.hideLstAddress = true;
        }
      }
    }
  }

  openFormEditDesktop(id, index) {
    this.addressIDUpdate = id;

    if (this.lstAddress[index].district == null) {
      const dialogRef = this.dialog.open(AppModalUpdateAddressComponent, {
        data: { addressId: id },
        width: '600px'
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res && res.event) {
          this.reloadAddressList();
        }
      });
      return;
    }

    if (this.isDesktop == true) {
      this.formType = 'edit';
      this.addressForm.patchValue(
        {
          fullname: this.lstAddress[index].fullname,
          province: this.lstAddress[index].province,
          phone: this.lstAddress[index].phone,
          address: this.lstAddress[index].address,
          is_company: this.lstAddress[index].is_company,
          is_default: this.lstAddress[index].is_default,
          user_id: this.lstAddress[index].user_id,
        },
        { onlySelf: true }
      );
      let province = this.lstAddressJson.find((x) => x.name == this.addressForm.value.province);
      if (province != null) this.lstDistrict = province.districts;
      this.addressForm.patchValue({
        district: this.lstAddress[index].district,
      });
      this.filteredOptionsLstDistrict = this.addressForm.get('district').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterDistrict(value))
      );

      let district = this.lstDistrict.find((x) => x.name == this.addressForm.value.district);
      if (district != null)
        this.lstWard = Object.values(JSON.parse(JSON.stringify(district.wards)));
      this.addressForm.patchValue({
        ward: this.lstAddress[index].ward,
      });
      this.filteredOptionsLstWard = this.addressForm.get('ward').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterWard(value))
      );
      this.ref.detectChanges();
      this.scrollToFormCreate();
      return;
    } else {
      if (!this.isModal) {
        this.router.navigate(['/myprofile/mybookaddress/' + id + '/edit']);
      } else {
        this.hideLstAddress = true;
        this.formType = 'edit';
        this.isEditing.emit(true);
        this.addressForm.patchValue({
          fullname: this.lstAddress[index].fullname,
          province: this.lstAddress[index].province,
          phone: this.lstAddress[index].phone,
          address: this.lstAddress[index].address,
          is_company: this.lstAddress[index].is_company,
          is_default: this.lstAddress[index].is_default,
          user_id: this.lstAddress[index].user_id,
        });

        let province = this.lstAddressJson.find((x) => x.name == this.addressForm.value.province);
        if (province != null)
          this.lstDistrict = Object.values(JSON.parse(JSON.stringify(province.districts)));
        this.addressForm.patchValue({
          district: this.lstAddress[index].district,
        });
        this.filteredOptionsLstDistrict = this.addressForm.get('district').valueChanges.pipe(
          startWith(''),
          map((value) => this._filterDistrict(value))
        );

        let district = this.lstDistrict.find((x) => x.name == this.addressForm.value.district);
        if (district != null)
          this.lstWard = Object.values(JSON.parse(JSON.stringify(district.wards)));
        this.addressForm.patchValue({
          ward: this.lstAddress[index].ward,
        });
        this.filteredOptionsLstWard = this.addressForm.get('ward').valueChanges.pipe(
          startWith(''),
          map((value) => this._filterWard(value))
        );
      }
    }
  }
  cancelEditModal() {
    this.hideLstAddress = false;
    this.formType = '';
    this.isEditing.emit(false);
    this.isCreateDone.emit(true);
  }
  resetDataForm() {
    this.addressForm.reset();

    this.addressForm.patchValue({
      province: '',
      district: '',
      ward: '',
    });
  }
}
